var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { Container } from '../../../common/styles/container';
// Utils
import styled from 'styled-components';
// Styles
import { pulseAnimation } from './pulseAnimation';
import { grey } from '../../../common/styles/colours';
export var Skeleton = styled(Container).attrs(function (_a) {
    var ariaLabel = _a.ariaLabel, ariaValueText = _a.ariaValueText;
    return ({
        'aria-busy': 'true',
        'aria-label': ariaLabel,
        'aria-valuetext': ariaValueText,
        role: 'progressbar',
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  opacity: 1;\n  ", ";\n"], ["\n  background-color: ", ";\n  display: block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  opacity: 1;\n  ", ";\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme.backgroundTertiary) !== null && _b !== void 0 ? _b : grey[300];
}, function (_a) {
    var width = _a.width;
    return width !== null && width !== void 0 ? width : '100%';
}, function (_a) {
    var height = _a.height;
    return height !== null && height !== void 0 ? height : '100%';
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius !== null && borderRadius !== void 0 ? borderRadius : '3px';
}, pulseAnimation);
var templateObject_1;
//# sourceMappingURL=Skeleton.js.map